const CANDIDATES_COLLECTION = "candidates";

const processDocs = (docs) => {
  const data = [];
  docs.forEach((doc) => {
    const elem = doc.data();
    elem.id = doc.id;
    data.push(elem);
  });
  return data;
};

const extractSnapshotData = (snap) => {
  if (!snap.exists) {
    return null;
  }

  return {
    id: snap.id,
    ...snap.data()
  };
};

function CandidatesMixin() {
  return {
    async findCandidatesByCampaignId(campaignId) {
      return this.collection(CANDIDATES_COLLECTION)
        .where("campaignId", "==", campaignId)
        .get()
        .then((querySnapshot) => processDocs(querySnapshot));
    },

    async updateCandidates(candidates) {
      const batch = this.batch();
      candidates.forEach((candidate) => {
        const candidateRef = this.collection(CANDIDATES_COLLECTION).doc(candidate.id);
        batch.update(candidateRef, candidate);
      });
      await batch.commit();
    },

    async findCandidate(candidateId) {
      return this.collection(CANDIDATES_COLLECTION)
        .doc(candidateId)
        .get()
        .then(extractSnapshotData);
    },

    async getCandidatesByThreadId(threadId) {
      return this.collection(CANDIDATES_COLLECTION)
        .where("chatbotThreadId", "==", threadId)
        .get()
        .then((querySnapshot) => processDocs(querySnapshot));
    },

    async findActiveCandidatesCountByOrganizationId(organizationId) {
      const snapshot = await this.collection(CANDIDATES_COLLECTION)
        .where("effectiveStatus", "==", "active")
        .where("orgaId", "==", organizationId)
        .count()
        .get();
      return snapshot.data().count;
    }
  };
}

module.exports = CandidatesMixin;
